var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9015,
    cy: 12.2881,
    rx: 12.4757,
    ry: 12.2881,
    fill: "#FFC736"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01697 5.73438C7.04123 5.73438 6.24681 6.5167 6.24609 7.47852C6.24609 8.44033 7.04052 9.22281 8.01697 9.22281C8.99306 9.22281 9.78707 8.44033 9.78707 7.47852C9.78707 6.5168 8.99301 5.73438 8.01697 5.73438Z",
    fill: "#182539"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34438 9.92383H6.68605C6.5596 9.92383 6.45703 10.0248 6.45703 10.1495V18.5771C6.45703 18.7017 6.5596 18.8027 6.68605 18.8027H9.34432C9.47083 18.8027 9.5734 18.7017 9.5734 18.5771V10.1495C9.57345 10.0248 9.47088 9.92383 9.34438 9.92383Z",
    fill: "#182539"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1427 9.82422C15.1699 9.82422 14.315 10.116 13.7933 10.5918V10.1491C13.7933 10.0244 13.6907 9.92344 13.5642 9.92344H11.0142C10.8877 9.92344 10.7852 10.0244 10.7852 10.1491V18.5767C10.7852 18.7013 10.8877 18.8023 11.0142 18.8023H13.67C13.7965 18.8023 13.8991 18.7013 13.8991 18.5767V14.4072C13.8991 13.2108 14.1225 12.4693 15.2374 12.4693C16.3359 12.4706 16.4181 13.2658 16.4181 14.4786V18.5767C16.4181 18.7013 16.5207 18.8023 16.6472 18.8023H19.3042C19.4307 18.8023 19.5332 18.7013 19.5332 18.5767V13.9538C19.5332 12.0311 19.1478 9.82422 16.1427 9.82422Z",
    fill: "#182539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.90eaaa14c6caad9f4a3c83eb519ab8a1.svg";
export { ForwardRef as ReactComponent };